module.exports = __webpack_public_path__ + "img/favorites.9ef2153e.svg";